import React, { FC } from 'react'

import classNames from 'classnames'

import Tag from '@components/shared/Tag'

import useTags from './hooks/useTags'
import { getTagDisplayName } from './utils/helpers'

interface Props {
  className?: string
}

const Tags: FC<Props> = ({ className }) => {
  const { tags, hasTags, removeFilter } = useTags()

  // If there are no tags, don't show anything
  if (!hasTags) return null
  return (
    <div className={classNames('flex flex-1', className)}>
      {Object.entries(tags).map(([tag, category]) => (
        <Tag
          key={tag}
          name={getTagDisplayName(tag, category)}
          clickHandler={() => removeFilter(tags[tag], tag)}
        />
      ))}
    </div>
  )
}

export default Tags
